import 'rxjs/Rx';
import 'zone.js/dist/task-tracking';
import {enableProdMode, Injector, NgModuleRef, NgZone} from '@angular/core';
import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';
import "zone.js/dist/task-tracking"

import { AppModule } from './app/app.module';
import {environment} from './environments/environment';
import 'rxjs/Rx';
import { DateHandler } from './app/shared/utils/DateHandler';
import { ErrorHandler } from '@ispm/shared/utils/ErrorHandler';
import { FormItemComponent } from '@ispm/dynamic-form/components/form-item/form-item.component';
import { WorklistComponent } from 'app/worklist/components/worklist/worklist.component';
import { clone } from 'lodash';
import {CoreActionCreatorService} from "@ispm/core/services/core-action-creator.service";
import {Store} from "@ngrx/store";

if (environment.production) {
  enableProdMode();
}

DateHandler.OverrideToISOString();
DateHandler.setToPlatformFormat();
ErrorHandler.consoleErrorToAlert();

WorklistComponent.updateCheckedState();
WorklistComponent.toggleRowsWithCheckbox();
FormItemComponent.OverrideOnInputBlur();

// setAngularJSGlobal(angular);
platformBrowserDynamic().bootstrapModule(AppModule)
  .then((platformRef: NgModuleRef<AppModule>) => {
  const injector: Injector = platformRef.injector;
  const _coreAC = injector.get(CoreActionCreatorService) as CoreActionCreatorService;
  const store = injector.get(Store);
  store.dispatch({type: '@ngrx/store/init'});
  _coreAC.setUpgradeInjectorStatus(true);

      if (window['ngRef']) {
        window['ngRef'].destroy();
      }

      window['ngRef'] = platformRef;

      const ngZone = platformRef.injector.get(NgZone);
      setInterval(() => {
        const taskTrackingZone = (<any> ngZone)._inner.getZoneWith('TaskTrackingZone');

        if (!taskTrackingZone) {
          throw new Error('\'TaskTrackingZone\' zone not found! Have you loaded \'node_modules/zone.js/dist/task-tracking.js\'?');
        }

        let tasks: any[] = taskTrackingZone._properties.TaskTrackingZone.getTasksFor('macroTask');
        tasks = clone(tasks);
        window['angularPendingTasks'] = tasks;

        // if (_.size(tasks) > 0) {
        //   console.log('ZONE pending tasks=', window['angularPendingTasks']);
        // }
      }, 1000);
    //}
  })
  .catch((err: any) => console.error(err));
